<app-header>
    <title>save your picture</title>
</app-header>
<main>

    <!-- <app-post-create></app-post-create> -->






    <router-outlet></router-outlet>
</main>